"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.palette = void 0;
var typography_1 = require("../../shared/typography");
var types_1 = require("../../types");
var resolveBrandBodyFont_1 = require("../../utils/resolveBrandBodyFont");
var overrides_1 = require("../../shared/overrides");
var overrides_2 = require("../aspendental/overrides");
var resolveBrandTypographyConfig_1 = require("../../utils/resolveBrandTypographyConfig");
var chips_1 = require("../../shared/chips");
var palette_1 = require("./palette");
Object.defineProperty(exports, "palette", { enumerable: true, get: function () { return palette_1.palette; } });
var typography_2 = require("./typography");
var buttons_1 = require("./buttons");
var alerts_1 = require("./alerts");
var cards_1 = require("./cards");
var chips_2 = require("./chips");
var badges_1 = require("./badges");
var overrides_3 = require("./overrides");
var fontFamily = (0, resolveBrandBodyFont_1.resolveBrandBodyFont)(types_1.TAGBrand.Enterprise);
var themeObj = {
    palette: palette_1.enterprisePalette,
    typography: (0, resolveBrandTypographyConfig_1.resolveBrandTypographyConfig)(types_1.TAGBrand.Enterprise),
    components: __assign(__assign(__assign({ MuiTypography: {
            defaultProps: { variantMapping: typography_1.typographyVariantMapping },
            variants: typography_2.enterpriseTypography,
        }, MuiButton: buttons_1.enterpriseButtons, MuiFab: { variants: buttons_1.enterpriseFloatingButtons }, MuiPaper: { variants: cards_1.paperVariants }, MuiAlert: alerts_1.enterpriseAlerts, MuiChip: {
            variants: __spreadArray(__spreadArray([], chips_2.chipVariants, true), badges_1.chipBadgeVariants, true),
            styleOverrides: {
                root: function (_a) {
                    var ownerState = _a.ownerState, theme = _a.theme;
                    var selectedChipStylesIcon = (0, chips_1.generateSelectedChipStylesWithIcon)(ownerState, theme);
                    var disabledChipStyles = (0, chips_2.generateDisabledChipStylesEnterprise)(theme);
                    return __assign(__assign({}, selectedChipStylesIcon), disabledChipStyles);
                },
            },
        }, MuiLink: {
            variants: [
                {
                    props: { variant: 'link' },
                    style: function (_a) {
                        var theme = _a.theme;
                        return ({
                            fontFamily: fontFamily,
                            fontWeight: 350,
                            fontSize: '1rem',
                            lineHeight: '1.25rem',
                            textAlign: 'center',
                            color: "var(--text-interactive, ".concat(theme.palette.text.interactive, ")"),
                            textDecorationColor: "var(--text-interactive, ".concat(theme.palette.text.interactive, ")"),
                            cursor: 'pointer',
                        });
                    },
                },
            ],
        } }, (0, overrides_1.sharedOverrides)(types_1.TAGBrand.Enterprise)), overrides_2.overrides), overrides_3.overrides),
};
exports.default = themeObj;
